import { render, staticRenderFns } from "./MiniProductCard.vue?vue&type=template&id=517d8762&scoped=true&"
import script from "./MiniProductCard.vue?vue&type=script&lang=ts&"
export * from "./MiniProductCard.vue?vue&type=script&lang=ts&"
import style0 from "./MiniProductCard.vue?vue&type=style&index=0&id=517d8762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d8762",
  null
  
)

export default component.exports